import EventEmitter from 'eventemitter3'

export default class Obj extends EventEmitter {
    constructor (opts) {
        super()

        this._passiveeventlisteners = false

        try {
            const testOpts = Object.defineProperty({}, 'passive', {
                get: () => {
                    this._passiveeventlisteners = true
                }
            })

            window.addEventListener('test', testOpts, testOpts)
            window.removeEventListener('test', testOpts, testOpts)
        }
        catch (err) {
            console.warn('Passive Listening Not Supported')
        }

        if (opts)
            this.extend(opts)
    }

    extend (obj = {}) {
        if (typeof obj !== 'object'
                || Array.isArray(obj))
            return this

        Object.keys(obj)
            .forEach(opt => {
                this[opt] = obj[opt]
            })

        return this
    }
}
